module.exports = __webpack_public_path__ + "media/images/front/not-logged-in-lp-renew/img_webinar_04-7c13a8ba163003e3b51a1f9f384dfedf.png";